$(document).ready(function() {

  $(document).on('click', '.js-change-item', function() {
    const $parent = $(this).closest('.item-list-details'),
          $section = $parent.find('.js-change-item-section'),
          $index = $parent.find('.js-change-item').index(this);  

    $(this).addClass('active').siblings().removeClass('active')
    $section.removeClass('active-section');
    $section.eq($index).addClass('active-section');
  });
  $(document).on('change', 'select.js-change-item-m', function() {
    const $parent = $(this).closest('.item-list-details'),
          $section = $parent.find('.js-change-item-section'),
          $index = parseInt($(this).val());

    $section.removeClass('active-section');
    $section.eq($index).addClass('active-section');
  });
});